import { ModelBase } from 'store/model-base';
import { INSUFFICIENT_AUTH_METHODS } from 'core/constants';

export class StepUpUpdateContact extends ModelBase {
    public static storeName: string = 'stepUpUpdateContact';

    public decision: string;
    public reason: string;
    public acrValues: string;
    public maxAge: string;
    public authorizationBaseUrl: string;
    public authorizationAltBaseUrl: string;
    public isInsufficientAuthMethods: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: StepUpUpdateContact = super.create<StepUpUpdateContact>(initData);
        toReturn.isInsufficientAuthMethods = toReturn.reason?.toLocaleLowerCase() === INSUFFICIENT_AUTH_METHODS;

        return super.create<T>(toReturn);
    }
}
